'use client';
import { Box, Text, useRadio } from '@chakra-ui/react';
import cn from 'classnames';

import Styles from './CustomRadioButton.module.scss';

const CustomRadioButton = (props: { radioValue: string; size?: string }) => {
  const { radioValue, size, ...radioProps } = props;
  const { state, getInputProps, getRadioProps, htmlProps, getLabelProps } =
    useRadio(radioProps);

  return (
    <Box
      as="label"
      {...htmlProps}
      className={Styles.radioButtonBlock}
      cursor="pointer"
    >
      <input {...getInputProps({})} hidden />

      <Box
        {...getRadioProps()}
        className={cn(
          Styles.radioButton,
          state.isChecked && Styles.active,
          size === 'lg' && Styles.radioButtonLg,
          size === 'sm' && Styles.radioButtonSm,
          size === 'md' && Styles.radioButtonMd,
          size === 'xl' && Styles.radioButtonXl,
        )}
      >
        <Text {...getLabelProps()}>{radioValue}</Text>
      </Box>
    </Box>
  );
};

export default CustomRadioButton;
